import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

export type CardComponentProps = {
  mode?: 'default' | 'highlight' | 'embedded';
} & ComponentPropsWithoutRef<'div'>;

export function getCardStyles({
  mode,
  className,
}: {
  mode: CardComponentProps['mode'];
  className?: string;
}) {
  return cn(
    'rounded-xs p-xl',
    mode === 'default' && 'border border-border-surface-minimal bg-white',
    mode === 'highlight' && 'bg-background-surface-minimal',
    mode === 'embedded' && 'rounded-none bg-white shadow-indentation-sm',
    className
  );
}

export const Card: FC<CardComponentProps> = ({
  mode = 'default',
  ...props
}) => {
  return (
    <div
      {...props}
      className={getCardStyles({ mode, className: props.className })}
    />
  );
};
